export const getBuildYear = (year: number | null) => {
  if (year === null) return "";
  return year;
};

export const formatBuildYear = (build_year?: string | null) => {
  if (!build_year) return undefined;
  if (build_year.includes("/")) return Number(build_year.split("/")[0]);
  if (build_year.includes("-")) return Number(build_year.split("-")[0]);
  return Number(build_year);
};
